import { RouteConfig } from 'vue-router'

const StartDrill = () => import('../views/drill-experience/StartDrill.vue')

export const startDrillRoute: RouteConfig = {
  path: '/start-drill',
  name: 'start_drill',
  component: StartDrill,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '天天跳绳运动Drill',
    ignoreLogin: true,
  },
}

export default [startDrillRoute]
